import {
  LabelInput,
  EntryTypeSelect,
  StandardDesignConfig,
  HideOnPdfToggle,
  RequiredToggle,
  ReadOnlyToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const DateDefaultSelect = {
  label: 'Default',
  settingType: 'selectInput',
  size: 'large',
  updateType: 'entry',
  property: 'default',
  choices: [
    { label: 'Current Date', value: null },
    { label: 'No Default (Blank)', value: 'BLANK' },
  ],
}

const DateStyleSelect = {
  label: 'Style',
  settingType: 'selectInput',
  size: 'large',
  updateType: 'entry',
  property: 'style',
  choices: [
    {
      label: 'MM/DD/YYYY',
      value: 0,
    },
    {
      label: 'DD/MM/YYYY',
      value: 1,
    },
    {
      label: 'YYYY/MM/DD',
      value: 2,
    },
  ],
}

export const DateStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'),
  DateDefaultSelect,
  DateStyleSelect,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
